<div class="account-form-wrapper" [hidden]="successfulMsg">
  <div class="registration-process step-0 v-row justify-content-center" *ngIf="!startSignupProcess">
    <div class="row">
      <div class="inner-fields col">
        <h1 class="signin-title">{{ translate.currentLang === 'en' ? 'Open Your CAL Investment Account' : 'আপনার CAL
          বিনিয়োগ অ্যাকাউন্ট খুলুন' }}</h1>
        <p class="signin-detail">{{ translate.currentLang === 'en' ? 'Enter your mobile number and email to get
          started. We\'ll send you a verification code.' : 'শুরু করতে আপনার মোবাইল নম্বর ও ইমেইল লিখুন। আমরা আপনাকে
          একটি যাচাইকরণ কোড পাঠাব।' }}</p>

        <div class="segmented-toggle">
          <div class="segment" [class.active]="selected === 'login'" (click)="goToLoginPage()">
            {{ translate.currentLang === 'en' ? 'Login' : 'লগইন' }}
          </div>

          <div class="segment" [class.active]="selected === 'signup'" (click)="selected = 'signup'">
            {{ translate.currentLang === 'en' ? 'Become an Investor' : 'একজন বিনিয়োগকারী হন' }}
          </div>
        </div>

        <div class="item-fields">
          <div class="send-verification-box m-t-xl">
            <form *ngIf="sendVerificationCodeFG" #form="ngForm" [formGroup]="sendVerificationCodeFG"
              (ngSubmit)="onSendSignupVerificationCodes(form)" class="form create-account" novalidate
              autocomplete="off">
              <div class="sign-opts d-none">
                <input type="radio" value="None" id="none" [formControl]="signUpMethod" class="sign-radio"
                  kendoRadioButton />
                <label class="sign-label" for="none">None</label>
              </div>
              <div style="margin-bottom: 20px" *ngIf="signUpMethod.value !== 'None'">
                <label class="hidden-label">{{ signUpMethod.value }} {{ translate.currentLang === 'en' ? 'Number' :
                  'নম্বর' }}</label>
                <input *ngIf="signUpMethod.value === 'NIC'" [formControl]="sendVerificationCodeFG.get('nic')"
                  type="text" autocapitalize="off" spellcheck="false" (keypress)="restrict($event)"
                  (paste)="onPaste($event)" placeholder="{{ 'sign_up.nic.nic_placeholder' | translate }}"
                  maxlength="{{ globalConfig === 'bn' ? 13 : 20 }}" />
                <div *ngIf="sendVerificationCodeFG.get('nic').invalid && sendVerificationCodeFG.get('nic').touched"
                  class="alert alert-danger">
                  <span *ngIf="globalConfig !== 'bn'" [hidden]="!sendVerificationCodeFG.get('nic').errors?.nic">{{
                    'sign_up.nic.nic_error' | translate
                    }}</span>
                  <span *ngIf="globalConfig === 'bn'" [hidden]="!sendVerificationCodeFG.get('nic').errors?.nic">{{
                    'sign_up.nic.nic_error_bn' | translate
                    }}</span>
                  <span [hidden]="!sendVerificationCodeFG.get('nic').errors?.requireIfTrue">{{
                    'sign_up.nic.nic_required' | translate
                    }}</span>
                </div>

                <input *ngIf="signUpMethod.value === 'Passport'" [formControl]="sendVerificationCodeFG.get('passport')"
                  type="text" autocapitalize="off" spellcheck="false" id="pp" (keypress)="restrict($event)"
                  (paste)="onPaste($event)" placeholder="{{ 'sign_up.passport.passport_placeholder' | translate }}"
                  maxlength="12" />
                <div
                  *ngIf="sendVerificationCodeFG.get('passport').invalid && sendVerificationCodeFG.get('passport').touched"
                  class="alert alert-danger">
                  <span [hidden]="!sendVerificationCodeFG.get('passport').errors?.passport">{{
                    'sign_up.passport.passport_error' | translate
                    }}</span>
                  <span [hidden]="!sendVerificationCodeFG.get('passport').errors?.requireIfTrue">{{
                    'sign_up.passport.passport_required' | translate
                    }}</span>
                </div>
              </div>

              <form-mobile-no [controls]="[
                  sendVerificationCodeFG.get('mobilePhoneCountryCode'),
                  sendVerificationCodeFG.get('mobilePhoneAreaCode'),
                  sendVerificationCodeFG.get('mobilePhoneNumber')
                ]" label="" help="" [showErrors]="form.submitted"
                [placeholder]="translate.currentLang === 'en' ? 'Enter your mob number' : 'আপনার মোবাইল নম্বর লিখুন'">
                <span [hidden]="!sendVerificationCodeFG.get('mobilePhoneAreaCode').errors?.required">
                  {{ 'sign_up.no_required' | translate }}
                </span>
                <span [hidden]="
                    !sendVerificationCodeFG.get('mobilePhoneNumber').errors?.requireIfTrue &&
                    !sendVerificationCodeFG.get('mobilePhoneNumber').errors?.pattern
                  ">
                  <span *ngIf="globalConfig === 'bn'; else sl">
                    {{ 'sign_up.no_invalid_bn' | translate }}
                  </span>
                  <span>
                    <ng-template #sl>
                      {{ 'sign_up.no_invalid' | translate }}
                    </ng-template>
                  </span>
                </span>
              </form-mobile-no>

              <form-text [control]="sendVerificationCodeFG.get('email')"
                [placeholder]="translate.currentLang === 'en' ? 'Enter your email address' : 'আপনার ইমেইল ঠিকানা লিখুন'"
                help="" [showErrors]="form.submitted" class="email-field" [autocomplete]="'email'">
                <span [hidden]="!sendVerificationCodeFG.get('email').errors?.required">{{ translate.currentLang === 'en'
                  ? 'Email is Required' : 'ইমেইল প্রয়োজন' }}</span>
                <span [hidden]="!sendVerificationCodeFG.get('email').errors?.email">{{ translate.currentLang === 'en' ?
                  'Email is invalid.' : 'ইমেইল অবৈধ।' }}</span>
              </form-text>
              <p class="already-have-account">
                <a (click)="goToLoginPage()" style="cursor: pointer;">{{ translate.currentLang === 'en' ? 'Already have
                  an account?' : 'ইতিমধ্যে একটি অ্যাকাউন্ট আছে?' }}</a>
              </p>
              <div class="alert alert-danger mb-4" [hidden]="!userAvailability">
                <span [hidden]="signUpMethod.value !== 'NIC'">{{ 'sign_up.nic.nic_note' | translate }}</span>
                <span [hidden]="signUpMethod.value !== 'Passport'">{{ 'sign_up.passport.passport_note' | translate
                  }}</span>
              </div>
              <div class="row button-row">
                <app-primary-button *ngIf="!verificationExceeded" id="btn-s-1"
                  [text]="(sentVerification && (translate.currentLang === 'en' ? 'Resend Verification Code' : 'যাচাইকরণ কোড পুনরায় পাঠান')) || (translate.currentLang === 'en' ? 'Send Verification Code' : 'যাচাইকরণ কোড পাঠান')"
                  [loading]="sentVeryficationInProgress" type="submit" [fullWidth]="true">
                </app-primary-button>
                <p class="signup-detail-2" *ngIf="!sentVerification">{{ translate.currentLang === 'en' ? 'Your
                  information is encrypted and securely stored.' : 'আপনার তথ্য এনক্রিপ্ট করা এবং নিরাপদে সংরক্ষণ করা
                  হয়েছে।' }}
                </p>
              </div>
              <!-- Debug: sentVerification = {{ sentVerification }} -->
              <!-- Test slide animation -->

              <p *ngIf="sentVerification" [slide]="sentVerification" class="precaution-msg alert alert-info">
                <span [hidden]="crmUserRegistrationFailure">
                  {{ 'sign_up.verification' | translate }} <a
                    href="mailto:info&#64;calbd.com.bd">info&#64;calbd.com.bd</a>
                </span>
              </p>
              <errors [on]="sendVerificationCodeErrors">
                {{ sendVerificationCodeErrors }}
              </errors>
              <div class="clearfix content-footer" [hidden]="!sendVerificationCodeErrors">
                <div class="w-100 text-center">
                  <button id="btn-s-2" type="button" class="w-100 btn btn-fill cursor-pointer"
                    [loading]="contactAdministratorInProgress" (click)="contactAdmin()">
                    {{ 'sign_up.contact_admin' | translate }}
                  </button>
                </div>
                <p>{{ 'sign_up.not_remember' | translate }}</p>
              </div>
            </form>
            <form *ngIf="verifySignupFG && sentVerification" #vform="ngForm" [formGroup]="verifySignupFG"
              (ngSubmit)="onVerifySignup(vform)" class="form create-account" novalidate>
              <div class="form-group p-relative text-center text-xl-start">

                <div class="row">
                  <div class="col-12 col-md-12 col-xl">
                    <input formControlName="verificationCode" type="text" class="form-control code-verify"
                      placeholder="{{ 'sign_up.verification_code_placeholder' | translate }}" />
                  </div>
                  <div class="col-12 col-md-12 col-xl-auto text-center mt-1 mt-xl-0">
                    <!-- <div class="text-end button-verify"> -->
                    <app-primary-button id="btn-s-3" [text]="'sign_up.verify_btn' | translate"
                      [loading]="verifyingCodeInProgress" type="submit" [fullWidth]="true">
                    </app-primary-button>
                    <!-- </div> -->
                  </div>
                </div>

                <div [hidden]="verifySignupFG.controls['verificationCode'].valid || !vform.submitted"
                  class="alert alert-danger">
                  <span [hidden]="!verifySignupFG.controls.verificationCode.errors?.required">{{
                    'sign_up.verification_error' | translate
                    }}</span>
                </div>
                <div class="form-errors alert alert-danger"
                  [hidden]="!verifySignupErrors || !verifySignupErrors.length">
                  <ul>
                    <li class="text-left" *ngFor="let error of verifySignupErrors">
                      {{ error }}
                    </li>
                  </ul>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="registration-process v-row" *ngIf="startSignupProcess">
    <div class="row">
      <div class="inner-fields col">
        <h1 class="global-title">{{ translate.currentLang === 'en' ? 'Secure Your Access. Start Investing.' : 'আপনার
          অ্যাক্সেস সুরক্ষিত করুন। বিনিয়োগ শুরু করুন।' }}</h1>
        <p class="global-subheading">{{ translate.currentLang === 'en' ? 'Complete these steps to activate your
          account.' : 'আপনার অ্যাকাউন্ট সক্রিয় করতে এই ধাপগুলি সম্পূর্ণ করুন।' }}</p>
        <div class="item-fields">
          <form #sform="ngForm" [formGroup]="userSignupFG" (ngSubmit)="onUserSignup(sform)"
            class="form create-account m-t-xl" novalidate autocomplete="off">


            <div class="form-group">
              <h2 class="global-title">{{ translate.currentLang === 'en' ? 'Let\'s start by getting to know you.' :
                'আপনাকে জানা দিয়ে শুরু করি।' }}</h2>
              <input [readonly]="!!crmUser || !!socialLoginUserDetails" formControlName="firstName" type="text"
                class="form-control" placeholder="{{ 'sign_up.name' | translate }}" autocomplete="given-name" />
              <div [hidden]="!userSignupFG.controls['firstName'].errors || !sform.submitted" class="alert alert-danger">
                <span [hidden]="!userSignupFG.controls.firstName.errors?.required">{{ 'sign_up.name_req' | translate
                  }}</span>
              </div>
            </div>

            <div class="form-group">

              <input [readonly]="!!crmUser || !!socialLoginUserDetails" formControlName="lastName" type="text"
                class="form-control" placeholder="{{ 'sign_up.last_name' | translate }}" autocomplete="family-name" />
              <div [hidden]="!userSignupFG.controls['lastName'].errors || !sform.submitted" class="alert alert-danger">
                <span [hidden]="!userSignupFG.controls.lastName.errors?.required">{{ 'sign_up.last_name_req' | translate
                  }}</span>
              </div>
            </div>
            <div class="form-group">
              <h2 class="global-title">{{ translate.currentLang === 'en' ? 'Now, let\'s secure your CAL account.' :
                'এখন, আপনার CAL অ্যাকাউন্ট সুরক্ষিত করি।' }}</h2>
              <input formControlName="password" type="password" class="form-control"
                placeholder="{{ 'sign_up.pwd_label' | translate }}" autocomplete="new-password" />
              <div class="description">
                {{ 'sign_up.pwd_description' | translate }}
              </div>
              <div [hidden]="userSignupFG.controls['password'].valid">
                <span [hidden]="
                    !userSignupFG.controls.password.errors?.required || (!sform.submitted && !userSignupFG.controls.password.touched)
                  " class="alert alert-danger">{{ 'sign_up.req' | translate }}</span>
                <span [hidden]="!userSignupFG.controls.password.errors?.password" class="alert alert-danger">{{
                  userSignupFG.controls['password'].errors?.password
                  }}</span>
              </div>
            </div>
            <div class="form-group">

              <input formControlName="confirmPassword" type="password" class="form-control"
                placeholder="{{ 'sign_up.retype' | translate }}" autocomplete="new-password" />
              <div
                *ngIf="userSignupFG.controls['confirmPassword'].invalid && userSignupFG.controls['confirmPassword'].touched"
                class="alert alert-danger">
                <span [hidden]="!userSignupFG.controls.confirmPassword.errors?.required">{{ 'sign_up.please_retype' |
                  translate }}</span>
              </div>
              <div *ngIf="userSignupFG.errors && (sform.submitted || userSignupFG.controls['confirmPassword'].touched)"
                class="alert alert-danger">
                <span [hidden]="!userSignupFG.errors?.misMatchPasswords">{{ 'sign_up.dont_match' | translate }}</span>
              </div>
            </div>
            <!--
            <div class="form-group m-t m-b-sm">
              <div class="recaptchaSlide">
                <custom-captcha [control]="userSignupFG.get('captchaText')" placeholder="Type the text" label="Enter CAPTCHA text shown in the image"
                  [showErrors]="sform.submitted" (captchaRequest)="captchaRequest($event)" [resetOnError]="resetOnError">
                  <span [hidden]="!userSignupFG.get('captchaText').errors?.required">The CAPTCHA field is required</span>
                </custom-captcha>
              </div>
            </div> -->
            <div class="form-group">
              <div class="form-check">
                <label class="radio-inline">
                  <input type="checkbox" class="form-check-input" formControlName="termsCondition" />
                  {{ 'sign_up.acc_terms' | translate }} <span (click)="openDisclaimer()"> <i
                      class="fas fa-external-link-alt"></i></span></label>
              </div>

              <div [hidden]="!userSignupFG.controls['termsCondition'].errors || !sform.submitted"
                class="alert alert-danger">
                <span [hidden]="!userSignupFG.controls.termsCondition.errors?.requiredToBeTruthy">{{ 'sign_up.req' |
                  translate }}</span>
              </div>
            </div>
            <div class="form-group">
              <app-primary-button id="btn-s-5" [text]="translate.currentLang === 'en' ? 'Save' : 'সংরক্ষণ করুন'"
                [loading]="onUserSignupInProgress" type="submit" [fullWidth]="true">
              </app-primary-button>
            </div>
            <errors style="position: relative; top: 10px" [on]="signUpError">
              {{ signUpError }}
            </errors>

          </form>



        </div>
      </div>
    </div>
  </div>
</div>
<app-help-box *ngIf="!sentVerification"></app-help-box>
<div class="account-form-wrapper" *ngIf="successfulMsg">
  <div class="success-msg">
    <div class="inner-fields">
      <h3>{{ 'sign_up.success' | translate }}</h3>

      <p>{{ 'sign_up.suc_det' | translate }}</p>
      <p>{{ 'sign_up.issue' | translate }}</p>
    </div>
  </div>
</div>